export default {"src":"/_next/static/media/logo-default.d9919ebb.svg","height":142,"width":532,"blurWidth":0,"blurHeight":0};